import { Component, Input, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Memoize } from '@app/providers/utils/memoize-decorator';

@Component({
  selector: 'pr-errors',
  templateUrl: './pr-errors.component.html',
  styleUrls: ['./pr-errors.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class PrErrorsComponent {
  @Input() control: UntypedFormControl;
  @Input() derrors: boolean = false;
  @Input() maskErrorMessage: string = 'Veuillez respecter le format :';
  @Input() phoneMask: boolean = false;

  Object = Object;

  dynamicErrors = {
    max: val => `Valeur maximum : ${val.max}`,
    min: val => `Valeur minimum : ${val.min}`,
    minlength: val => `Valeur minimum : ${val?.requiredLength}`,
    maxlength: val => `Valeur maximum : ${val?.requiredLength}`,
    pattern: val => `Le format de ce champ est invalide.`,
    validatePhoneNumber: val => `le numéro de téléphone  est invalide`,
    mask: val =>
      this.phoneMask
        ? 'ce numéro de téléphone est invalide'
        : this.maskErrorMessage + ' ' + val?.requiredMask,
    // TODO:Must be add multiple keys
  };

  errors = {
    required: 'ce champs est requis',
    validDate: 'la date est invalide, le format attendu est JJ/MM/YYYY',
    notInFutureDate: 'la date ne peut pas être dans le futur',
    todayOrInFutureDate: 'veuillez saisir la date actuelle ou future',
  };

  constructor() {}

  ngOnInit() {}
  @Memoize()
  getErrorMessageForPattern(pattern: RegExp): string {
    const messageMap: { [pattern: string]: string } = {
      '^0$': 'Le champ doit être un nombre entier.',
      '^[0-9]{1,3}(,[0-9]{3})*(.[0-9]+)?$':
        'Le champ doit être un nombre décimal.',
      '^[0-9]+$': 'Le champ doit contenir uniquement des chiffres.',
      '^[a-zA-Z]+$': 'Le champ doit contenir uniquement des lettres.',
    };

    for (const key in messageMap) {
      const re = new RegExp(key);
      if (re.test(pattern.source)) {
        return messageMap[key];
      }
    }

    return 'Le format de ce champ est invalide.';
  }
}
